<app-common-form [loading]="isSubmitting" (save)="onSubmit($event)"></app-common-form>
